import { Component, OnInit } from '@angular/core';
import { AdvtService } from '../../_services/advt.service';
import { AlertService } from '../../_services';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';


@Component({
  selector: 'app-radio-list',
  templateUrl: './radio-list.component.html',
  styleUrls: ['./radio-list.component.css']
})
export class RadioListComponent implements OnInit {
  user_id: any;
  mainLoader: any;
  musicList: any;
  musicCount: Number;
  loading = false;
  pageSize: any = 10;
  category_id: Number = 3;
  generes: any;
  musicForm: FormGroup;
  selectedGenerId = 0;
  playIcon = '../../../assets/images/play-icon.png';




  constructor(private advtService: AdvtService,
    private fb: FormBuilder,
    private alertService: AlertService,
  ) { }

  ngOnInit() {
    this.mainLoader = '../../assets/images/BigLoader.gif';
    this.getListSubCategories();

    if (localStorage.getItem('currentUser')) {
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.user_id = userInfo.result.id;
    }
    this.getRadios();
    this.musicForm = this.fb.group({
      'category_meta_id': ['']
    });
  }

  /**
   * Get Radio Listing
   * @param offset Offset
   */
  public getRadios(offset = 0) {
    this.loading = true;
    const params = {
      gener_id: this.selectedGenerId,
      limit: this.pageSize,
      offset
    };
    this.advtService.getRadios(params)
      .subscribe(data => {
        this.musicList = data.result;
        this.musicCount = data.count;
        this.loading = false;
      }, error => {
        // this.alertService.error(error);
      });
  }

  public getListSubCategories() {
    this.advtService.getListSubCategories(this.category_id)
      .subscribe(data => {
        this.generes = data;
      }, error => {
        this.alertService.error(error);
      });
  }

  /**
   * On Change Genere
   * @param value selectedGener
   */
  onGenreChange(value) {
    this.selectedGenerId = value;
    this.getRadios();
  }

  /**
   * Pagination
   * @param num Pagination Number
   */
  pagingAgent(num) {
    const offset = (num * this.pageSize) - this.pageSize;
    this.getRadios(offset);
  }

 
}



// WEBPACK FOOTER //
// ./src/app/authorized-data/radio-list/radio-list.component.ts